import {Button, ModalPopup} from '@kit';

import React, {useEffect, useState} from 'react';

import {Class} from '../../generated/types';
import {navigate, useRoute} from '../../lib/routes';
import {FeatureView, PartialFeature} from '../feature-view';
import {GridView} from './grid-view';
import {ListView} from './list-view';

import css from './class-table.module.css';

type Props = {
	heroClass: Class;
	features: PartialFeature[];
};

export const ClassTable: React.FC<Props> = ({heroClass, features}) => {
	const router = useRoute();
	const [showingFeatureId, setShowingFeatureId] = useState<string | null>(null);
	useEffect(() => {
		setShowingFeatureId(router.query.featureId as string);
	}, [router.query]);

	const handleCloseFeature = () => {
		navigate('class', {id: heroClass.id});
		setShowingFeatureId(null);
	};

	return (
		<div className={css.wrapper}>
			{showingFeatureId && heroClass.features && (
				<ModalPopup open={true} onClose={handleCloseFeature} historyEntry={false}>
					<FeatureView
						feature={features.find((feature) => feature.id === showingFeatureId)!}
						parentObject={{type: 'class', parentId: heroClass.id}}
						alwaysH1
					/>
					<ul className={'modal-popup-buttons'}>
						<li>
							<Button onClick={handleCloseFeature}>Закрыть</Button>
						</li>
					</ul>
				</ModalPopup>
			)}
			<div className={css.wide}>
				<GridView heroClass={heroClass} features={features} />
			</div>
			<div className={css.narrow}>
				<ListView heroClass={heroClass} features={features} />
			</div>
		</div>
	);
};
